/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpinWheelSegment } from './SpinWheelSegment';
import {
    SpinWheelSegmentFromJSON,
    SpinWheelSegmentFromJSONTyped,
    SpinWheelSegmentToJSON,
    SpinWheelSegmentToJSONTyped,
} from './SpinWheelSegment';

/**
 * 
 * @export
 * @interface SpinWheelConfigPublicResponse
 */
export interface SpinWheelConfigPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof SpinWheelConfigPublicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelConfigPublicResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelConfigPublicResponse
     */
    modalTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelConfigPublicResponse
     */
    modalDescription?: string;
    /**
     * 
     * @type {Array<SpinWheelSegment>}
     * @memberof SpinWheelConfigPublicResponse
     */
    segments: Array<SpinWheelSegment>;
}

/**
 * Check if a given object implements the SpinWheelConfigPublicResponse interface.
 */
export function instanceOfSpinWheelConfigPublicResponse(value: object): value is SpinWheelConfigPublicResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('segments' in value) || value['segments'] === undefined) return false;
    return true;
}

export function SpinWheelConfigPublicResponseFromJSON(json: any): SpinWheelConfigPublicResponse {
    return SpinWheelConfigPublicResponseFromJSONTyped(json, false);
}

export function SpinWheelConfigPublicResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelConfigPublicResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'modalTitle': json['modalTitle'] == null ? undefined : json['modalTitle'],
        'modalDescription': json['modalDescription'] == null ? undefined : json['modalDescription'],
        'segments': ((json['segments'] as Array<any>).map(SpinWheelSegmentFromJSON)),
    };
}

export function SpinWheelConfigPublicResponseToJSON(json: any): SpinWheelConfigPublicResponse {
    return SpinWheelConfigPublicResponseToJSONTyped(json, false);
}

export function SpinWheelConfigPublicResponseToJSONTyped(value?: SpinWheelConfigPublicResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'modalTitle': value['modalTitle'],
        'modalDescription': value['modalDescription'],
        'segments': ((value['segments'] as Array<any>).map(SpinWheelSegmentToJSON)),
    };
}

